// extracted by css-extract-rspack-plugin
export default {"root":"root-1f934","chevron":"chevron-WQ0gj","popup":"popup-1XAxD"};